import {
  buildAdditionalContactCard,
  type ContactCardOverrides,
} from './additionalContactCard';

export const buildBuyersAttorneyContactCard = (
  contactType: 'attorney' | 'counterpartyAttorney',
) => {
  return buildAdditionalContactCard({
    contactType,
    contactLabel: "Buyer's Attorney",
    overrides: {
      outerTitle: "Buyer's Attorneys",
      addByDefault: true,
      hideByDefault: false,
      addText: "Buyer's Attorney",
      noEntryText: null,
      displayFields: (displayFields) =>
        displayFields.concat([
          {
            name: `contacts.${contactType}.x.street1`,
            type: 'address',
          },
          {
            name: `contacts.${contactType}.x.street2`,
            type: 'address',
          },
          {
            name: `contacts.${contactType}.x.city`,
            type: 'address',
          },
          {
            name: `contacts.${contactType}.x.state`,
            type: 'address',
          },
          {
            name: `contacts.${contactType}.x.zip`,
            type: 'address',
          },
        ]),
      fields: {
        role: {
          label: 'Role',
          placeholderText: 'Attorney, Assistant, etc',
        },
      },
    } satisfies ContactCardOverrides,
  });
};
